// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 289 ? "1dbfff34" : chunkId) + "." + {"289":"5d15eeb338d6370f","426":"a1a3e965339e33c8"}[chunkId] + ".js";
};